import { Box, Button, Chip, Grid, Typography, useTheme } from '@mui/material'
import { useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import { WaterTestKitRequestsSelectors } from '../../../store/waterTestKitRequests'
import { WaterTestKitResultsSelector } from '../../../store/waterTestKitResults'

export const PersonalRecommendationsCard = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const resultsSummary = useSelector(WaterTestKitResultsSelector.makeLatestResultsSummaryShort)

  return (
    <Grid
      container
      direction="row"
      flexWrap={{xs:'wrap', md:"nowrap"}}
      sx={{
        background: theme.palette.blue[800],
        borderRadius: (theme.shape.borderRadius as number) / 2,
        color: 'white',
        p: 3,
      }}
    >
      <Grid direction="column" container sx={{ flexGrow: 1}}>
        <Typography variant="h6">Your Personal Recommendations</Typography>
        <Typography variant="subtitle2">
          Based on your latest water analysis, we've identified 6 personalized recommendations to
          optimize your water quality.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, my: 2, flexWrap: 'wrap' }}>
          {resultsSummary?.Good && <Chip label={`Maintain (${resultsSummary.Good.count})`} variant="outlined-success" />}
          {resultsSummary?.Caution && <Chip label={`Monitor (${resultsSummary.Caution.count})`} variant="outlined-warning" />}
          {(resultsSummary?.Low || resultsSummary?.High) && <Chip label={`Action Needed (${((resultsSummary.High && resultsSummary.High.count) || 0) + ((resultsSummary.Low && resultsSummary.Low.count) || 0)})`} variant="outlined-error" />}
          {resultsSummary?.NA && <Chip label={`Neutral (${resultsSummary.NA.count})`} variant="outlined-neutral" />}

        </Box>
      </Grid>
      <Grid sx={{ flexShrink: 0 }}>
        <Button
          variant="contained"
          sx={{width:'fit-content', whiteSpace:'nowrap'}}
          size="medium" onClick={()=> navigate('/profile/recommendations')}>
          Upgrade to Pro
        </Button>
      </Grid>
    </Grid>
  )
}